import { useQuery } from "@tanstack/react-query";
import { fetchInvoiceSettings } from "../../../../../../enums/queryFunction/Fetch";
import { INVOICE_SETTINGS } from "../../../../../../enums/QueryKeys";

export function useGetInvoiceSettings(clinicId) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [INVOICE_SETTINGS, clinicId],
    queryFn: () => fetchInvoiceSettings(clinicId),
    enabled: Boolean(clinicId),
  });

  return { data, isLoading, error, refetch };
}
